import { render, staticRenderFns } from "./EditDriver.vue?vue&type=template&id=44a5fdc0"
import script from "./EditDriver.vue?vue&type=script&lang=js"
export * from "./EditDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditDriver.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a5fdc0')) {
      api.createRecord('44a5fdc0', component.options)
    } else {
      api.reload('44a5fdc0', component.options)
    }
    module.hot.accept("./EditDriver.vue?vue&type=template&id=44a5fdc0", function () {
      api.rerender('44a5fdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/views/EditDriver.vue"
export default component.exports